import { useEffect } from 'react';
import { useUpdate } from 'react-use';

export const useTimeout = (timeoutInterval: number) => {
  const update = useUpdate();

  useEffect(() => {
    const interval = setInterval(() => {
      // forcing update every minute for message relative timestamp update
      update();
    }, timeoutInterval);

    return () => {
      clearInterval(interval);
    };
  }, [update, timeoutInterval]);
};
